import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="events--filters"
export default class extends Controller {
  toggleFutureEvents(event) {
    const url = new URL(window.location.href)
    if (event.target.checked) {
      url.searchParams.set('include_future_events', '1')
    } else {
      url.searchParams.delete('include_future_events')
    }
    
    Turbo.visit(url.toString())
  }
}
